$(function() {
  // Open search
  $(".js-search").on("click", function () {
    const parentEl = window.matchMedia("(min-width: 768px)").matches ? '.df-header__nav' : '.df-header__main';
    const top = $(parentEl).offset().top + $(parentEl).outerHeight() - 1;
    const height = $('#js-search').find('.container').outerHeight() + 70;
    $("#js-search").css('top', top + 'px');
    $("#js-search").animate({ minHeight: height, }, 300, function () {
      $("#js-search").addClass("js-opened");
      $("#js-search").css('height', 'auto');
      $("#js-search").find('input').trigger("focus");
    });
  });

  // Close search
  $("#js-search-close").on("click", function () {
    $("#js-search").animate({ height: 0, minHeight: 0 }, 300, function() {
      $("#js-search-input").val('');
      $(this).find(".df-search__results__title").empty();
      $(this).find(".df-search__results__inner").empty();
      $(this).find(".df-search__results__empty").addClass("d-none");
      $(this).find('.df-search__results__loader').removeClass("active");
      $(this).find(".df-search__results").addClass("d-none");
      $(this).removeClass("js-opened");
    });
  });

  // Search function
  let timeout = null;

  function search(value, $results) {
    if (timeout) {  
      clearTimeout(timeout);
    }
    timeout = setTimeout(function() {
      $results.removeClass("d-none");
      $results.find(".df-search__results__inner").addClass('d-none')
      $results.find(".df-search__results__empty").addClass("d-none");
      $results.find('.df-search__results__loader').addClass("active");
      $.ajax({
        url: '/search',
        method: 'get',
        data: { query: value },
        dataType: 'json',
        success: function(data) {
          $results.find('.df-search__results__loader').removeClass("active");
          $results
            .find(".df-search__results__title")
            .html(`${$results.data("title")}<br/>«${value}»`);
          let html = '';
          if (data && data.length) {
            data.forEach((category) => {
              html += `
              <div class="df-search__results__category">
                <a href="${category.url}" class="df-search__results__category__title">
                  ${category.category_name} (<span classcategory="text-secondary">${category.total}</span>)
                </a>
              `;
              if (category.results && category.results.length) {
                category.results.forEach((product) => {
                  html += `
                    <a href="${product.url}" class="df-search__results__category__item">
                      ${product.label}
                    </a>
                  `;
                });
              }
              html += `</div>`;
            });
          }

          if (html) {
            $results.find(".df-search__results__inner").removeClass('d-none')
            $results.find(".df-search__results__inner").html(html);
          } else {
            $results.find(".df-search__results__inner").addClass('d-none')
            $results.find(".df-search__results__empty").removeClass("d-none");
          }
        },
        error: function(error) {
          console.error(error);
        }
      });
    }, 500);
  }

  // Search in header
  $("#js-search-input").on("keyup", function (e) {
    const value = e.target.value;
    const $results = $(this).parent().next();

    if (value) {
      search(value, $results);
    } else {
      $results.find(".df-search__results__title").empty();
      $results.find(".df-search__results__inner").empty();
      $results.find(".df-search__results__empty").addClass("d-none");
      $results.next('.df-search__results__loader').removeClass("active");
      $results.addClass("d-none");
    }
  });

  // Search in menu
  $("#js-menu-search").on("keydown", function (e) {
    const value = e.target.value;
    const $results = $(this).parent().next();

    if (value) {
      search(value, $results);
    } else {
      $results.find(".df-search__results__title").empty();
      $results.find(".df-search__results__inner").empty();
      $results.find(".df-search__results__empty").addClass("d-none");
      $results.next('.df-search__results__loader').removeClass("active");
      $results.addClass("d-none");
    }
  });
});